import { useState, useEffect, useCallback } from 'react';
import { getSettingsRepository } from '../../../main/factories/settings-dependencies.factory';
import {
  ContactInformationDTO,
  SiteSettingDTO,
} from '../../../infrastructure/repositories/http-settings.repository';

export const useSettings = () => {
  const [contactInfo, setContactInfo] = useState<ContactInformationDTO | null>(null);
  const [siteSettings, setSiteSettings] = useState<SiteSettingDTO[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const settingsRepo = getSettingsRepository();

  const loadSettings = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const [contact, settings] = await Promise.all([
        settingsRepo.getContactInformation(),
        settingsRepo.getSiteSettings(),
      ]);
      setContactInfo(contact);
      setSiteSettings(settings);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar configuraciones');
    } finally {
      setLoading(false);
    }
  }, [settingsRepo]);

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  return {
    contactInfo,
    siteSettings,
    loading,
    error,
    refresh: loadSettings,
  };
};
